export default "__VITE_ASSET__ToHodgbg__"